import React from 'react';
import {useMenu} from '../../../hooks/useMenu';
import ProgressBarView from '../../views/progressbarView';
import ZeroVerFinished from './zero-ver-finished';

function VerificationPB() {
  const {onComponent} = useMenu();
  return (
    <ProgressBarView
      title="Zero Verification"
      content="Verifying Zero"
      onExit={() => onComponent(<ZeroVerFinished />)}
    />
  );
}

export default VerificationPB;
